<ng-template [ngIf]="item && item.coverAssetID">
  <article class="w-full h-full asset-item-basic" [ngClass]="{ 'cursor-pointer': !published }" attr.aria-labelledby="asset-{{ assetId }}-name" tabindex="0">
    <div class="w-1/6 align-top inline-block mt-4">
      <div class="align-middle">
        <mat-checkbox [disabled]="disableCheckbox" class="example-margin" (change)="onChangeSelectedCollection($event, item, index, published)" [checked]="item?.checked"> </mat-checkbox>
      </div>
    </div>
    <div class="w-2/6 h-full inline-block asset-preview1 align-top">
      <figure *ngIf="!editFlag" class="w-[95%] h-full">
        <img *ngIf="item.coverAssetID.previewUrl; else fallbackImage" [src]="item.coverAssetID.previewUrl" [alt]="item.coverAssetID.name" class="asset-image" />
        <ng-template #fallbackImage>
          <mat-icon *ngIf="item.coverAssetID.assetType | assetTypeToIconName; else defaultIcon" class="material-icons-outlined asset-icon">{{
            item.coverAssetID.assetType | assetTypeToIconName
          }}</mat-icon>

          <ng-template #defaultIcon>
            <mat-icon class="material-icons-outlined asset-icon">block</mat-icon>
          </ng-template>
        </ng-template>
      </figure>

      <figure *ngIf="editFlag" class="w-[95%] h-full">
        <img *ngIf="item.coverAssetID.imageUrl" class="asset-image" [src]="item.coverAssetID.imageUrl | imageLoading | async" [alt]="item.coverAssetID.name" />
        <ng-template #fallbackImage>
          <mat-icon *ngIf="item.coverAssetID.assetType | assetTypeToIconName; else defaultIcon" class="material-icons-outlined asset-icon">{{
            item.coverAssetID.assetType | assetTypeToIconName
          }}</mat-icon>
          <ng-template #defaultIcon>
            <mat-icon class="material-icons-outlined asset-icon">block</mat-icon>
          </ng-template>
        </ng-template>
      </figure>
    </div>

    <div class="w-3/6 pl-2 inline-block align-top">
      <div id="asset-{{ assetId }}-name" class="asset-name1">
        <span [matTooltip]="item.name">{{ item.name }}</span>
      </div>
    </div>
  </article>
</ng-template>
